export default __webpack_public_path__ + "img/BB_RT_NOMA_WF.1f569364399e3d22e8730d9a761be1f9.jpg";